/**
 * Open task detailed event
 * @param taskId
 */
export function sendOpenTaskEvent(taskId: string, forceSetDetailedTask = false) {
  console.log('sendOpenTaskEvent', taskId, forceSetDetailedTask);
  const openTaskEvent = new CustomEvent('ng2:tasks:open-task', { detail: { taskId, forceSetDetailedTask } });
  document.dispatchEvent(openTaskEvent);
}

/**
 * Open task detailed
 * @param taskId
 */
export function openTaskDetailedInDashboard(taskId: string) {
  const webComponentTag = 'nim-task-dashboard';
  const isDashboardLoaded = () => document.createElement(webComponentTag).constructor !== HTMLElement;

  let IID: NodeJS.Timeout | number | null = null;
  let TID: NodeJS.Timeout | number | null = null;

  if (isDashboardLoaded()) {
    sendOpenTaskEvent(taskId);
  } else {
    IID = setInterval(() => {
      if (isDashboardLoaded()) {
        sendOpenTaskEvent(taskId);
        IID && clearInterval(IID);
        TID && clearTimeout(TID);
      }
    }, 1000);
    TID = setTimeout(() => {
      IID && clearInterval(IID);
    }, 60e3);
  }
}
